// ============================================================================
// FRENCH TRANSLATIONS - BIBLE VERSES
// ============================================================================
// Collection de versets inspirants avec références Strong

export const bibleVerses = [
  {
    reference: "Philippiens 4:13",
    text: "Je puis tout par celui qui me fortifie",
    version: "segond1910",
    theme: "force",
    strongNumbers: {
      "puis": "G1411", // δύναμις (dynamis) = pouvoir, force
      "fortifie": "G1743" // ἐνδυναμόω (endynamoo) = renforcer
    },
    context: "Paul parle de sa capacité à faire face à toutes situations grâce au Christ"
  },
  {
    reference: "Psaume 23:1",
    text: "L'Éternel est mon berger, je ne manquerai de rien",
    version: "segond1910",
    theme: "protection",
    strongNumbers: {
      "berger": "H7462", // רָעָה (ra'ah) = paître, garder
      "manquerai": "H2637" // חָסֵר (chaser) = manquer, avoir besoin
    },
    context: "David exprime sa confiance totale en la providence divine"
  },
  {
    reference: "Jean 3:16",
    text: "Car Dieu a tant aimé le monde qu'il a donné son Fils unique",
    version: "segond21",
    theme: "amour",
    strongNumbers: {
      "aimé": "G25", // ἀγαπάω (agapao) = aimer inconditionnellement
      "donné": "G1325" // δίδωμι (didomi) = donner, offrir
    },
    context: "Le verset le plus célèbre sur l'amour de Dieu pour l'humanité"
  },
  {
    reference: "Philippiens 4:7",
    text: "Et la paix de Dieu, qui surpasse toute intelligence, gardera vos cœurs",
    version: "segond21",
    theme: "paix",
    strongNumbers: {
      "paix": "G1515", // εἰρήνη (eirene) = paix, harmonie
      "gardera": "G5432" // φρουρέω (phroureo) = garder, protéger
    },
    context: "Promesse de protection divine par la paix intérieure"
  },
  {
    reference: "Psaume 119:105",
    text: "Ta parole est une lampe à mes pieds, et une lumière sur mon sentier",
    version: "segond1910",
    theme: "guidance",
    strongNumbers: {
      "lampe": "H5216", // נִיר (niyr) = lampe, luminaire
      "lumière": "H216" // אוֹר (or) = lumière, éclairage
    },
    context: "La Parole de Dieu comme guide dans la vie quotidienne"
  },
  {
    reference: "Proverbes 3:5-6",
    text: "Confie-toi en l'Éternel de tout ton cœur, et ne t'appuie pas sur ta sagesse",
    version: "segond1910",
    theme: "confiance",
    strongNumbers: {
      "confie": "H982", // בָּטַח (batach) = avoir confiance
      "cœur": "H3820" // לֵב (leb) = cœur, esprit, volonté
    },
    context: "Invitation à faire confiance à Dieu plutôt qu'à nos propres capacités"
  },
  {
    reference: "Matthieu 5:14",
    text: "Vous êtes la lumière du monde. Une ville située sur une montagne ne peut être cachée",
    version: "segond21",
    theme: "témoignage",
    strongNumbers: {
      "lumière": "G5457", // φῶς (phos) = lumière, éclairage spirituel
      "monde": "G2889" // κόσμος (kosmos) = monde, univers
    },
    context: "Jésus encourage ses disciples à être témoins dans le monde"
  }
];

export default bibleVerses;
